module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "frame-wrapper",
    class: {
      pad10: _vm.withPadding
    }
  }, [(_vm.iframeSrc) ? _c('iframe', {
    ref: "innerFrame",
    attrs: {
      "src": _vm.iframeSrc,
      "frameborder": "0"
    }
  }) : _c('p', [_vm._v("\n        嵌入错误\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cf793fa","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inner-frame/inner-frame.vue
// module id = 623
// module chunks = 0